import React from 'react'
import exact from 'prop-types-exact'
import { DoorOpenIcon } from 'components/icons'

const propTypes = {}

const defaultProps = {}

function OpenToEmploymentIndicator() {
  return (
    <div className="flex-horizontal open-to-partnerships">
      <div className="star-icon">
        <DoorOpenIcon aria-hidden />
      </div>
      <p>
        <strong>Seeking Employment with Organizations</strong>
      </p>
    </div>
  )
}

OpenToEmploymentIndicator.propTypes = exact(propTypes)
OpenToEmploymentIndicator.defaultProps = defaultProps

export default React.memo(OpenToEmploymentIndicator)
